export const GET_ORDERS_BEGIN = 'GET_ORDERS_BEGIN';
export const GET_ORDERS_ERROR = 'GET_ORDERS_ERROR';
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS';
export const GET_PRODUCTS_BEGIN = 'GET_PRODUCTS_BEGIN';
export const GET_PRODUCTS_ERROR = 'GET_PRODUCTS_ERROR';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_ADMINS_BEGIN = 'GET_ADMINS_BEGIN';
export const GET_ADMINS_ERROR = 'GET_ADMINS_ERROR';
export const GET_ADMINS_SUCCESS = 'GET_ADMINS_SUCCESS';
export const GET_SINGLE_ORDER_BEGIN = 'GET_SINGLE_ORDER_BEGIN';
export const GET_SINGLE_ORDER_ERROR = 'GET_SINGLE_ORDER_ERROR';
export const GET_SINGLE_ORDER_SUCCESS = 'GET_SINGLE_ORDER_SUCCESS';
export const UPDATE_ORDER_STATUS = 'UPDATE_ORDER_STATUS';
export const CREATE_NEW_ADMIN = 'CREATE_NEW_ADMIN';
export const CREATE_NEW_PRODUCT = 'CREATE_NEW_PRODUCT';
export const UPDATE_NEW_PRODUCT_IMAGES = 'UPDATE_NEW_PRODUCT_IMAGES';
export const UPDATE_EXISTING_PRODUCT = 'UPDATE_EXISTING_PRODUCT';
export const GET_SINGLE_PRODUCT_BEGIN = 'GET_SINGLE_PRODUCT_BEGIN';
export const GET_SINGLE_PRODUCT_ERROR = 'GET_SINGLE_PRODUCT_ERROR';
export const GET_SINGLE_PRODUCT_SUCCESS = 'GET_SINGLE_PRODUCT_SUCCESS';
